import styled from "styled-components";
import add from "../../image/add.png";
import del from "../../image/delete.png";
import media from "../../static/style/media";

// Main container for the entire page
export const Container = styled.div`
  margin: 0 auto;
  max-width: 1300px;
  padding: 40px 20px;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  ${media.small`
    padding: 20px 10px;
  `}
`;

// Content container for inner elements
export const ContentContainer = styled.div`
  padding: 30px 60px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  ${media.small`
    padding: 20px 10px;
  `}
`;

// Manage button shared styles
export const ManageBtn = styled.span`
  cursor: pointer;
  padding: 15px 30px;
  background-color: ${(props) => props.setColor || "#f0f0f0"};
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 15px;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: ${(props) => props.setColor || "#e7f0ff"};
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  ${media.small`
    font-size: 1rem;
    padding: 10px 20px;
  `}
`;

// Add and delete buttons
export const AddBtn = styled(ManageBtn)``;
export const DeleteBtn = styled(ManageBtn)``;

// Add and delete images
export const AddImg = styled.img.attrs({
  src: `${add}`,
})`
  width: 30px;
  height: 30px;
  ${media.small`
    width: 25px;
    height: 25px;
  `}
`;

export const DeleteImg = styled.img.attrs({
  src: `${del}`,
})`
  width: 30px;
  height: 30px;
  ${media.small`
    width: 25px;
    height: 25px;
  `}
`;

// List title for sections
export const ListTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: bold;
  color: #175eb4;
  margin-bottom: 25px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 10px;
`;

// Table and table elements
export const Table = styled.table`
  width: 100%;
  margin-top: 20px;
  border-spacing: 0;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const TableHeaderRow = styled.tr`
  background-color: #f0f0f0;
`;

export const TableRow = styled.tr`
  cursor: ${(props) => (props.isSelectMode ? "pointer" : "default")};
  transition: background-color 0.2s ease;
  &:hover {
    background-color: ${(props) => (props.isSelectMode ? "#f0f8ff" : "none")};
  }
`;

// Table headers and cells with padding and clean typography
export const TableHeader = styled.th`
  background-color: #f7f9fc;
  padding: 12px 20px;
  font-weight: bold;
  font-size: 1rem;
  color: #333;
  border-bottom: 2px solid #e8e8e8;
  text-align: left;

  ${media.small`
    font-size: 0.9rem;
    padding: 10px 15px;
  `}
`;

export const TableCell = styled.td`
  padding: 10px 20px;
  font-size: 0.9rem;
  color: #555;
  border-bottom: 1px solid #eee;
  text-align: center;

  ${media.small`
    font-size: 0.85rem;
    padding: 8px 10px;
  `}
`;

// Scrollable table container
export const TableContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

// Title section with flexbox layout
export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 1.5rem;
  color: #175eb4;
  border-bottom: 2px solid #ddd;
  padding-bottom: 15px;

  ${media.small`
    font-size: 1.3rem;
  `}
`;

export const TitleLeftContainer = styled.div``;
export const TitleRightContainer = styled.div``;
